module.exports = __webpack_public_path__ + "06a4f1e81bfb585535413a9f1f145e30.svg";